/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentResumeeExamViewModel } from "../types/StudentResumeeExamViewModel.ts";
import { studentCourseExamViewModelSchema } from "./studentCourseExamViewModelSchema.ts";

export const studentResumeeExamViewModelSchema = z.object({
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  classStudentId: z.optional(
    z.number().int().describe("ID do aluno na turma."),
  ),
  courseName: z.string().describe("Nome do curso.").nullish(),
  classStudentName: z.string().describe("Nome da turma do aluno.").nullish(),
  averageGrade: z
    .number()
    .describe("Média geral das notas do aluno no curso. Opcional.")
    .nullish(),
  registrationId: z.optional(
    z.number().int().describe("ID da matrícula associada."),
  ),
  courseExams: z
    .array(z.lazy(() => studentCourseExamViewModelSchema))
    .describe("Lista de provas do curso para este aluno.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do registro. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do registro. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação do registro.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração do registro.")
    .nullish(),
}) as unknown as ToZod<StudentResumeeExamViewModel>;
